module.exports = __webpack_public_path__ + "img/ghonaim-portrait.d2dc0647.webp";